import type {Result, UseCase} from 'framework';
import type {SettingsError} from '../../domain/errors';
import type {UserProfile, WritableBodyMetrics} from '../../domain/user-profile';
import type {SettingsRepository} from '../ports/settings.repository';

export class UpdateBodyMetrics implements UseCase<[WritableBodyMetrics], UserProfile> {
  constructor(private readonly repository: SettingsRepository) {}

  execute(metrics: WritableBodyMetrics): Promise<Result<UserProfile, SettingsError>> {
    return this.repository.updateBodyMetrics(metrics);
  }
}
